import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import g1 from "../assets/g1.jpeg"
import g2 from "../assets/g2.jpeg"
import g3 from "../assets/g3.jpeg"
import g4 from "../assets/g4.jpeg"
import g5 from "../assets/g5.jpeg"
import g6 from "../assets/g6.jpeg"
import g7 from "../assets/g7.jpeg"
import g8 from "../assets/g8.jpeg"
import g10 from "../assets/g10.jpeg"
import g11 from "../assets/g11.jpeg"
import g12 from "../assets/g12.jpeg"
import g13 from "../assets/g13.jpeg"
import g14 from "../assets/g14.jpeg"
import g15 from "../assets/g15.jpeg"
import g16 from "../assets/g16.jpeg"
import g17 from "../assets/g17.jpeg"
import g18 from "../assets/g18.jpeg"
import g19 from "../assets/g19.jpeg"
import g20 from "../assets/g20.jpeg"
import g21 from "../assets/g21.jpeg"


const images = [
  g1,g2,g3,g4,g5,g6,g7,g8,g10,g11,g12,g13,g14,g15,g16,g17,g18,g19,g20,g21
]

const Gallery = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <section className="bg-black py-12 px-4 min-h-screen">
      <div className="max-w-7xl mx-auto">
        {/* Gallery Grid */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 space-y-4">
          {images.map((src, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="relative overflow-hidden rounded-xl cursor-zoom-in group"
              onClick={() => setSelectedImg(src)}
            >
              <img
                src={src}
                alt={`Inspection site ${index + 1}`}
                className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-110 group-hover:brightness-110"
              />
              {/* Subtle Overlay on Hover */}
              <div className="absolute inset-0 bg-blue-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </motion.div>
          ))}
        </div>
      </div>

      {/* Lightbox / Modal */}
      <AnimatePresence>
        {selectedImg && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImg(null)}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4 md:p-12 cursor-zoom-out"
          >
            <motion.img
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              src={selectedImg}
              className="max-w-full max-h-full rounded-lg shadow-2xl border border-gray-800"
            />
            <button 
              className="absolute top-8 right-8 text-white text-4xl hover:text-blue-400 transition-colors"
              onClick={() => setSelectedImg(null)}
            >
              &times;
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Gallery;